import * as array from 'd3-array'
import * as scale from 'd3-scale'

export default function (layout, dimensions) {
  let plot = layout.plots[0]
    , points = array.merge(plot.series.map(s => s.points ))
    , padding = 30
    , groupScale = scale.scaleTime().domain(array.extent(points, p => p.title))
                                    .range([padding, dimensions.width - padding])

  return {
    center: groupScale,
    groupScale: groupScale,
    plotScale: scale.scaleBand()
                    .domain([0])
                    .range([0, dimensions.width])
                    .paddingInner(0)
                    .paddingOuter(0)
  }
}
